import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=561a8250&scoped=true"
import script from "./agentDetail.vue?vue&type=script&lang=js"
export * from "./agentDetail.vue?vue&type=script&lang=js"
import style0 from "./agentDetail.vue?vue&type=style&index=0&id=561a8250&prod&lang=css"
import style1 from "./agentDetail.vue?vue&type=style&index=1&id=561a8250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a8250",
  null
  
)

export default component.exports